/** The document kinds an invoice can be read from, as the UI labels them. */
export const SOURCE_KIND_LABEL: Record<string, string> = {
  order_confirmation: 'confirmation',
  invoice_document: 'invoice doc',
  shipment_manifest: 'manifest',
  refund_notice: 'refund notice',
  portal: 'portal',
  other: 'other',
};
